import React from 'react';
import { Dropdown, Icon } from 'semantic-ui-react';
import { FormattedMessage } from 'react-intl';
import urls, { codeUrl, relativeUrl } from '@/constants/urls';
import RibbonMenu from '@/containers/ribbon/RibbonMenu';
import Selectors from '../hooks/selectors';

const AccessLauncherMenu = () => {
  const {
    allowApprove, allowCreate, allowRead, allowTasks, code,
  } = Selectors.useAccessLauncherMenu();

  return (
    <Dropdown
      className="aridhia-access-launcher-menu"
      icon={null}
      trigger={(<RibbonMenu name="access" message="fair.launcher.access" icon="key" />)}
    >
      <Dropdown.Menu>
        {allowCreate && (
          <Dropdown.Item as="a" href={codeUrl(urls.REQUEST, code, '#')} selected={false}>
            <Icon name="plus" className="primary" />
            <FormattedMessage id="request.header.menu.new" />
          </Dropdown.Item>
        )}
        {allowRead && (
          <>
            {allowCreate && (<Dropdown.Divider />)}
            <Dropdown.Item as="a" href={`#${relativeUrl(urls.REQUESTS)}`} selected={false}>
              <Icon name="list alternate" className="primary" />
              <FormattedMessage id="request.header.menu.my" />
            </Dropdown.Item>
          </>
        )}
        {allowApprove && !allowRead && (<Dropdown.Divider />)}
        {allowApprove && (
          <Dropdown.Item as="a" href={`#${relativeUrl(urls.REVIEW)}`} selected={false}>
            <Icon name="thumbs up" className="primary" />
            <FormattedMessage id="request.header.menu.review" />
          </Dropdown.Item>
        )}
        {allowTasks && (
          <Dropdown.Item as="a" href={`#${relativeUrl(urls.TASKS)}`} selected={false}>
            <Icon name="tasks" className="primary" />
            <FormattedMessage id="request.header.menu.tasks" />
          </Dropdown.Item>
        )}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default AccessLauncherMenu;
